import React from "react"
import {
  Toast as GluestackToast,
  ToastDescription,
  ToastTitle,
  useToast,
} from "./gluestack/toast"

export interface ToastOptions {
  title: string
  description?: string
  action?: "success" | "error" | "warning" | "info" | "muted"
  variant?: "solid" | "outline"
  duration?: number
  placement?:
    | "top"
    | "bottom"
    | "top left"
    | "top right"
    | "bottom left"
    | "bottom right"
}

export const useToastNotification = () => {
  const toast = useToast()

  const showToast = React.useCallback(
    (options: ToastOptions) => {
      const {
        title,
        description,
        action = "muted",
        variant = "solid",
        duration = 3000,
        placement = "top",
      } = options

      const id = Math.random().toString()

      toast.show({
        id,
        placement,
        duration,
        render: ({ id: toastId }) => {
          const uniqueToastId = "toast-" + toastId
          return (
            <GluestackToast
              nativeID={uniqueToastId}
              action={action}
              variant={variant}
              className="max-w-[400px]"
            >
              <ToastTitle>{title}</ToastTitle>
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </GluestackToast>
          )
        },
      })

      return id
    },
    [toast],
  )

  return { showToast }
}

// Export the toast hook as the main API
export { useToastNotification as useToast }
